import logoIcon from '../../../Root/App/icons/SAN.svg';

export default function LogoIcon({ className = 'w-5 h-5' }) {
  return (
    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full">
      <img className={className} src={logoIcon} alt="Logo" />
    </span>
  );
}
